import React, { Component } from "react";
import Highcharts from "highcharts/highmaps";
import HighchartsReact from "highcharts-react-official";

const defaultOptions = {
    chart: {
        borderWidth: 1,
        height: "600px",
        backgroundColor: '#3A3B44',
        animation: false
    },

    title: {
        text: '',
        margin: 30
    },

    exporting: {
        sourceWidth: 600,
        sourceHeight: 500
    },

    legend: {
        layout: 'vertical',
        borderWidth: 1,
        borderColor: '#B2B2B2',
        backgroundColor: '#E8E8E8',
        floating: true,
        verticalAlign: 'top',
        padding: 10,
        y: 330,
        x: 380
    },

    mapNavigation: {
        enabled: true
    },

    series: [{
        animation: false,
        joinBy: ['postal-code', 'code'],
        dataLabels: {
            enabled: true,
            color: '#FFFFFF',
            format: '{point.code}'
        },
        tooltip: {
            pointFormat: '{point.code}: {point.value}'
        }
    }],
    tooltip: {
        backgroundColor: "#FFF",
        borderRadius: 8,
        borderWidth: 1,
        padding: 14,
        style: {
            color: "#333333",
            fontSize: "14px",
            fontFamily: "Arial",
            lineHeight: "22px"
        },
        formatter() {
            return `Response Type: <b>${this.series.chart.options.series.name}</b>
                <br/>Score Type: <b>${this.key}</b>
                <br/>Score: <b>${this.y}</b>`   
        }
    },
};

const getChartOptions = (topology, data, title, height, colorAxis, tooltipFormatter) => {
    let chartOptions = JSON.parse(JSON.stringify(defaultOptions));

    chartOptions.chart.map = topology;
    chartOptions.series[0].data = data;
    if (height) {
        chartOptions.chart.height = height;
    }
    if(title) {
        chartOptions.title.text = title;
    }
    if(colorAxis) {
        chartOptions.colorAxis = colorAxis;
    }
    if(typeof tooltipFormatter === "function") {
        chartOptions.tooltip.useHTML = true;
        chartOptions.tooltip.formatter = tooltipFormatter;
    }
    return chartOptions;
};

class CountryChart extends Component {
    constructor(props) {
      super(props);
    }

  render() {
    Highcharts.setOptions(this.props.containerId, {});
    let chartOptions = getChartOptions(this.props.topology, this.props.data, this.props.title, this.props.height, 
        this.props.colorAxis, this.props.tooltipFormatter);


      return (
          <div id={this.props.containerId}>

                {chartOptions ? <HighchartsReact
                                    constructorType={"mapChart"} 
                                    options={{ ...chartOptions }}
                                    highcharts = { Highcharts }
                                /> : <h1>...loading...</h1>}
        </div>
      )
  }
}


export default CountryChart;